import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.css'],
})
export class PageContainerComponent {
  @Input() tables: any[]; //this is not used, just a placeholder for the copy directive and the unit test to pass.

  constructor() {}
}
